import React, { useState } from 'react'
import { useLocation, useParams } from 'react-router-dom'
import Banners from '../../../GlobalComponents/User/Banners'
import Pagenation from '../../../GlobalComponents/User/Pagenation'
import MobileProductLevelTeam from '../../../../Mobile/User/MobilePages/MobileTeams/MobileProductLevelTeam'
import CustomTextField from '../../../../../customComponents/CustomTextField'

const ViewTeam = () => {
	const location = useLocation()
	const { users } = location.state || []
	const { level } = useParams()
	const [searchTerm, setSearchTerm] = useState('')

	const filteredUsers = users.filter(
		(user) =>
			user.registerId.toLowerCase().includes(searchTerm.toLowerCase()) ||
			user.fullName.toLowerCase().includes(searchTerm.toLowerCase()) ||
			user.mainUser.registerId.toLowerCase().includes(searchTerm.toLowerCase()) ||
			user.mainUser.fullName.toLowerCase().includes(searchTerm.toLowerCase())
	)

	return (
		<>
			<div>
				<div className='main-width display'>
					<div className='row d-flex w-auto justify-content-center'>
						<div className='col-lg-12'>
							<div class='card w-95 card-body mt-2 min-vh-100'>
								<h2 className='source-serif-4 text-normal text-dark'>
									<i class='ri-team-line class-name mx-md-2 text-success ' aria-hidden='true'></i>
									Level No - {level}
								</h2>
								<div className='align-items-center mb-2 container-fluid mt-2'>
									<div className='d-flex justify-content-end text-end'>
										<div class='input-group input-group-outline w-20'>
											<input
												type='text'
												class='form-control'
												placeholder='Search....'
												value={searchTerm}
												onChange={(e) => setSearchTerm(e.target.value)}
											/>
										</div>
									</div>
								</div>

								<div className='card w-100 text-center mx-auto p-2 mb-3 bg-gold-light'>
									<div className='table-responsive border-radius-2xl'>
										<table className='table align-items-center mb-0'>
											<thead>
												<tr>
													<th className='text-uppercase text-dark text-md font-weight-bold'>S.NO</th>

													<th className='text-uppercase text-dark text-md font-weight-bold'>Level No</th>
													<th className='text-uppercase text-dark text-md font-weight-bold'>User Id</th>
													<th className='text-uppercase text-dark text-md font-weight-bold'>User Name</th>
													<th className='text-uppercase text-dark text-md font-weight-bold'>Upliner Id</th>
													<th className='text-uppercase text-dark text-md font-weight-bold'>Upliner Name</th>
												</tr>
											</thead>
											<tbody className='bg-white'>
												{filteredUsers.map((user, index) => (
													<tr key={user._id}>
														<td className='text-dark text-md font-weight-normal'>{index + 1}</td>
														<td className='text-dark text-md font-weight-normal'>Level No - {level}</td>
														<td className='text-dark text-md font-weight-normal'>{user.registerId}</td>
														<td className='text-dark text-md font-weight-normal'>{user.fullName}</td>
														<td className='text-dark text-md font-weight-normal'>{user.mainUser.registerId}</td>
														<td className='text-dark text-md font-weight-normal'>{user.mainUser.fullName}</td>
													</tr>
												))}
											</tbody>
										</table>
									</div>
								</div>
								{/* <Pagenation /> */}
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className='display-full'>
				<MobileProductLevelTeam users={filteredUsers} level={level} />
			</div>
		</>
	)
}

export default ViewTeam
